<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{aLang.c_list}} khai báo y tế
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <!-- <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item label="Nền tảng">
                      <el-input
                        type="text"
                        v-model="mData.tableRules.dataSearch.value.platform"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Phiên bản hiện tại">
                      <el-input
                        type="number"
                        v-model="mData.tableRules.dataSearch.value.current"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Phiên bản thấp nhất">
                      <el-input
                        type="number"
                        v-model="mData.tableRules.dataSearch.value.min"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                  >{{aLang.c_search}}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>-->
        <b-row>
          <b-col md="8">
            <div class="text-left mb-0">
              <b-row>
                <b-col md="4">
                  <el-select
                    v-model="mData.dataDefault.loai_dich"
                    placeholder="Loại khai báo y tế"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listLoaiDich"
                      :key="item.code"
                      :label="item.text"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col md="4">
            <div class="text-right mb-2">
              <!-- <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                plain
              >{{aLang.c_showHideSearch}}</el-button>-->
              <el-button @click="fn_handleKhaibao('create')" type="info" plain>Khai báo</el-button>
              <!-- <el-button @click="fn_handle('goBack')" type="info" plain>{{aLang.c_back}}</el-button> -->
            </div>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
          :row-class-name="tableRowClassName"
          :row-style="handCellMouse"
          ref="tableKhaiBaoDich"
        >
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>

          <el-table-column
            label="Loại khai báo y tế"
            width="auto"
            :sortable="mData.tableRules.allowSorting"
          >Khai báo y tế Covid-19</el-table-column>

          <el-table-column
            prop="createdTime"
            :sortable="mData.tableRules.allowSorting"
            label="Thời điểm tạo"
            :formatter="fn_formatterDatetime"
            width="200"
            align="center"
          ></el-table-column>

          <el-table-column :label="aLang.c_action" align="center" width="150px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handleKhaibao('update', scope.row.id)"
                v-b-popover.hover.left="aLang.c_update"
              >
                <i class="fa fa-edit"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handleKhaibao('detail', scope.row.id)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div
              v-if="mData.tableRules.allowSelect"
            >{{aLang.c_select}}: {{mData.tableRules.recordSelected.length}}</div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>

    <!-- modal khai bao dich-->
    <el-dialog
      :close-on-click-modal="false"
      title="Khai báo y tế"
      :visible.sync="mData.dialog.KhamDich.visible"
      width="70%"
      top="51px"
    >
      <div class="card-body scroll-y-80vh">
        <b-embed type="iframe" aspect="16by9" :src="mData.dialog.KhamDich.url" allowfullscreen></b-embed>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import KhaiBaoDichModel from "./KhaiBaoDichModel";
import KhaiBaoDichApi from "../../../moduleApi/KhaiBaoDichApi";
import Hssk831Api from "../../../moduleApi/Hssk831Api";
import moment from "moment";
import { Base64 } from "js-base64";
import { sha256 } from "js-sha256";
import { Buffer } from "buffer";

export default {
  props: {
    propKhamDich: Object
  },
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "KhaiBaoDich", //requied
        tableRules: MethodService.copyObject(KhaiBaoDichModel.tableRules),
        dataDefault: {
          loai_dich: "1",
          listLoaiDich: [
            {
              code: "1",
              text: "Dịch Covid-19"
            }
          ],
          inforNguoiDan: {},
          urlSurvey: ""
        },
        dialog: {
          KhamDich: {
            visible: false,
            index: 0,
            viewMode: "create",
            url: ""
          }
        }
      }
    };
  },

  methods: {
    //backgrouptable
    tableRowClassName({ row }) {
      console.log("rowClass", row);
      let data = row.result;
      let value = data.reduce((elemnt1, elemnt2) => {
        if (elemnt2.code == "col_ho" && elemnt2.value == "Có") {
          elemnt1.push("Ho");
        }
        if (elemnt2.code == "col_sot" && elemnt2.value == "Có") {
          elemnt1.push("Sốt");
        }
        if (elemnt2.code == "col_khotho" && elemnt2.value == "Có") {
          elemnt1.push("Khó Thở");
        }
        if (elemnt2.code == "col_viemphoi" && elemnt2.value == "Có") {
          elemnt1.push("Viêm phổi");
        }
        if (elemnt2.code == "col_dauhong" && elemnt2.value == "Có") {
          elemnt1.push("Đau họng");
        }
        if (elemnt2.code == "col_metmoi" && elemnt2.value == "Có") {
          elemnt1.push("Mệt mỏi");
        }
        return elemnt1;
      }, []);
      
       if (value.length>0 && value.length<3) {
          return 'warning-row';
        } else if (value.length >3) {
          return 'error-row';
        }
        return 'success-row';
    },
    handCellMouse() {
      this.$refs.tableKhaiBaoDich.$options._parentVnode.elm.classList.remove(
        "el-table--enable-row-hover"
      );
    },
    //get list table
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl && !this.propKhamDich) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch
          }
        });
      }
      let currentUser = MethodService.getCurrentUser();
      let card_code = currentUser.account;
      if (this.propKhamDich && this.propKhamDich.card_code) {
        card_code = this.propKhamDich.card_code;
      }
      dataFilter.filters +=
        "result.code=col_card_code&result.value=" + card_code;

      let res = await KhaiBaoDichApi.list(dataFilter);

      this.mData.tableRules.data = res.result;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
    },

    //xử lý dữ liệu đầu ra
    // changeData(data) {},

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
    },

    //delete
    async fn_delete(id) {
      await KhaiBaoDichApi.delete(id);
      this.fn_initTable();
    },

    //khóa tài khoản
    async fn_disable(id, disable) {
      await KhaiBaoDichApi.disable(id, disable);
      this.fn_initTable();
    },

    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_formatterDate(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    },
    async SinhUrl(type, dataConvert, id) {
      let currentUser = MethodService.getCurrentUser();
      
      let card_code = currentUser.account;
      if (this.propKhamDich && this.propKhamDich.card_code) {
        card_code = this.propKhamDich.card_code;
      }
      function toQueryString(obj, path) {
        if (obj === null || obj === undefined || typeof obj == "function")
          return "";

        if (
          typeof obj == "string" ||
          typeof obj == "number" ||
          typeof obj == "boolean"
        )
          return obj;

        if (Array.isArray(obj))
          return obj
            .map(function(item) {
              return toQueryString(item, path);
            })
            .join(",");

        var arr = [];
        for (var m in obj) {
          if (!obj.hasOwnProperty(m)) continue;

          var key = (path ? path : "") + m;
          arr.push(key + "=" + toQueryString(obj[m], key));
        }
        return arr.join("&");
      }
      let DataAll = {};
      let dataRender = {};

      function convertObjectToBase64(dataSurvey) {
        let objJsonStr = JSON.stringify(dataSurvey);
        let objJsonB64 = Buffer.from(objJsonStr).toString("base64");
        return objJsonB64;
      }

      if (type == "create") {
        dataRender = this.getDataFillter();
        DataAll.prefillData = {
          col_card_code: card_code
        };
        DataAll.prefillData = Object.assign(DataAll.prefillData, dataRender);
        DataAll.viewMode = "create";
      } else if (type == "detail") {
        DataAll.prefillData = dataConvert;
        DataAll.viewMode = "detail";
      } else if (type == "update") {
        DataAll.prefillData = dataConvert;
        DataAll.prefillData._id = id;
        DataAll.viewMode = "create";
      }
      const dataBase64 = convertObjectToBase64(DataAll.prefillData);
      DataAll.prefillData = encodeURIComponent(dataBase64);

      DataAll.appCode = "BIIN";
      DataAll.env =
        window.MyConfig.Environment == "product" ? "product" : "dev";
      DataAll.callbackUrl = "";
      DataAll.secretKey =
        window.MyConfig.Environment == "product"
          ? "BIIN-Production"
          : "BIIN-Dev";
      DataAll.hashCode = await sha256(
        DataAll.secretKey +
          "," +
          dataBase64 +
          "," +
          DataAll.callbackUrl +
          "," +
          DataAll.appCode +
          "," +
          DataAll.env
      );
      let url = "";
      if (this.propKhamDich && this.propKhamDich.isDoctor) {
        url = window.MyConfig.surveyUrl_bs + toQueryString(DataAll);
      } else {
        url = window.MyConfig.surveyUrl_bn + toQueryString(DataAll);
      }
      return url;
    },

    getDataFillter() {
      try {
        let data = {};
        let DetailInfor = this.mData.dataDefault.inforNguoiDan;
        if (DetailInfor && DetailInfor.Bhyts && DetailInfor.Bhyts[0]) {
          data.col_bhyt = DetailInfor.Bhyts[0].BhytNumber;
        }
        if (DetailInfor && DetailInfor.People) {
          if (DetailInfor.People.CmndNumber) {
            data.col_cmnd = DetailInfor.People.CmndNumber;
          }
          if (DetailInfor.People.GenderName) {
            data.col_gender = DetailInfor.People.GenderName;
          }
          if (DetailInfor.People.Phone) {
            data.col_sdt = DetailInfor.People.Phone;
          }
          if (DetailInfor.People.NationalName) {
            data.col_international = DetailInfor.People.NationalName;
          }
          if (DetailInfor.People.LastName || DetailInfor.People.FirstName) {
            data.col_hoten =
              DetailInfor.People.LastName + " " + DetailInfor.People.FirstName;
          }
          if (
            DetailInfor.People.ProvinceName &&
            DetailInfor.People.DistrictName
          ) {
            data.col_address =
              DetailInfor.People.DistrictName +
              " " +
              DetailInfor.People.ProvinceName;
          }
          if (DetailInfor.People.Dob) {
            data.col_dob = moment(
              DetailInfor.People.Dob,
              "YYYY:MM:DDTHH:mm:ss.SSSZZ"
            ).format();
          }
        }
        return data;
      } catch (err) {
        console.log("loi", err);
        return {};
      }
    },
    async getDataFillterDetail(data, type, id) {
      let objectConvert = {
        surveyResultId: data.id,
        // surveyId: data.surveyId,
        SurveyToken: data.surveyToken
      };
      data.result.forEach(item => {
        objectConvert[item.code] = item.value;
      });

      let url = await this.SinhUrl(type, objectConvert, id);

      // window.location.href = url;
      this.mData.dialog.KhamDich.url = url;
      this.mData.dialog.KhamDich.visible = true;
    },
    async getDetailKhaiBao(id, type) {
      let res = await KhaiBaoDichApi.findById(id);
      if (res.result) {
        this.getDataFillterDetail(res.result, type, id);
      }
    },
    async fn_handleKhaibao(type, id) {
      if (type == "create") {
        if (this.propKhamDich && this.propKhamDich.isDoctor) {
          if (!this.propKhamDich.card_code) {
            window.toastr.info("Bạn cần tìm kiếm người dân trước!");
            return;
          }
        }

        let url = await this.SinhUrl(type);
        // window.location.href = url;
        
        this.mData.dialog.KhamDich.url = url;
        this.mData.dialog.KhamDich.visible = true;
      }
      if (type == "update") {
        this.getDetailKhaiBao(id, "update");
      }
      if (type == "detail") {
        this.getDetailKhaiBao(id, "detail");
      }
    },
    async fn_initData() {
      let currentUser = MethodService.getCurrentUser();
      let card_code = currentUser.account;
      if (this.propKhamDich && this.propKhamDich.card_code) {
        card_code = this.propKhamDich.card_code;
      }

      let req_getAllInForNguoiDan = Hssk831Api.getAllInForNguoiDan(card_code);

      let res_getAllInForNguoiDan = await req_getAllInForNguoiDan;
      this.mData.dataDefault.inforNguoiDan = res_getAllInForNguoiDan.result;
    }
  },
  watch: {
    "mData.dialog.KhamDich.visible": function(newVal, oldVal) {
      var _this = this;
      if (newVal == false && oldVal == true) {
        _this.fn_initTable();
      }
    }
  },

  //run after render view
  created() {
    this.fn_hashUrl();
    this.fn_initData();
  },
  mounted() {
    this.fn_initTable();
  }
};
</script>
<style >
.el-table .warning-row {
  background: #ffff0087 !important;
}
.el-table .error-row {
  background: #ff2f0087 !important;
}
.el-table .success-row {
  background-color: white!important;
}

.error-row:hover {
  background-color: #ff2f00b8 !important;
}
.warning-row:hover {
  background-color: #ffff00e0 !important;
}
.success-row:hover:hover {
  background-color: #dcdcdc52!important;;
}
</style>
